"use strict";
// @ts-ignore
try {
    self['workbox:core:5.1.4'] && _();
}
catch (e) { }
